import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS,
    FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING,
    FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
    FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS,
    FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING,
    FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
    FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS,
    FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING,
    FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
    FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS,
    FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_FETCHING,
    FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_FAIL
} from '../actions/enduranceScoreActions';

// Workers
export function* fetchDailyEnduranceScoreDataSaga(action) {
    try {
        yield put({
            type: FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING
        });

        const { startDate } = action.payload;
        const response = yield call(gcApi.get, `metrics-service/metrics/endurancescore?calendarDate=${startDate}`);

        yield put({
            type: FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
            enduranceScoreData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
            enduranceScoreData: null
        });
    }
}

export function* fetchWeeklyEnduranceScoreDataSaga(action) {
    try {
        yield put({
            type: FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING
        });

        const { startDate, endDate } = action.payload;
        const response = yield call(
            gcApi.get,
            `metrics-service/metrics/endurancescore/stats?startDate=${startDate}&endDate=${endDate}&aggregation=weekly`
        );

        yield put({
            type: FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
            enduranceScoreData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
            enduranceScoreData: null
        });
    }
}

export function* fetchMonthlyEnduranceScoreDataSaga(action) {
    try {
        yield put({
            type: FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING
        });

        const { startDate, endDate } = action.payload;
        const response = yield call(
            gcApi.get,
            `metrics-service/metrics/endurancescore/stats?startDate=${startDate}&endDate=${endDate}&aggregation=monthly`
        );

        yield put({
            type: FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
            enduranceScoreData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
            enduranceScoreData: null
        });
    }
}

export function* fetchLatestEnduranceScoreDataSaga() {
    try {
        yield put({
            type: FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_FETCHING
        });

        const response = yield call(gcApi.get, `metrics-service/metrics/endurancescore`);

        yield put({
            type: FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
            enduranceScoreData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
            enduranceScoreData: null
        });
    }
}

// Watcher
export const enduranceScoreReportsSagas = [
    takeEvery(FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS, fetchWeeklyEnduranceScoreDataSaga),
    takeEvery(FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS, fetchMonthlyEnduranceScoreDataSaga),
    takeEvery(FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS, fetchDailyEnduranceScoreDataSaga),
    takeEvery(FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS, fetchLatestEnduranceScoreDataSaga)
];
